module.exports = __webpack_public_path__ + "img/PS32.5477ed6b.png";